import { Component, HostListener, OnInit } from '@angular/core';
import { AuthService } from '../../modules/auth/services/auth.service';
import { DepartmentsWiseCompanyService } from '../../core/services/departments-wise-company.service';
import { UserService } from '../../core/services/user.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-admin-layout',
  templateUrl: './admin-layout.component.html',
  styleUrls: ['./admin-layout.component.scss'],
})
export class AdminLayoutComponent implements OnInit {
  @HostListener('document:keydown', ['$event'])
  onKeyboardEvent(event: KeyboardEvent) {
    if (
      event.key === 'Enter' &&
      document.activeElement instanceof HTMLElement &&
      document.activeElement.tagName === 'INPUT'
    ) {
      event.preventDefault();
    }
  }

  isCollapsed = false;
  depOptions: any[] = [];
  userDepartments: any[] = [];

  loggedInUser: any = {};
  departmentName: any = '';
  loggedInUserName = '';
  loggedInUserProfilePic = '';

  openMap: { [name: string]: boolean } = {
    user: false,
    fleet: false,
    driver: false,
    customer: false,
    agent: false,
    supplier: false,
    booking: false,
  };

  constructor(
    private authService: AuthService,
    private departmentsService: DepartmentsWiseCompanyService,
    private userService: UserService,
    public router: Router,
  ) {}

  async logout(): Promise<any> {
    await this.authService.logout();
  }

  async ngOnInit(): Promise<any> {
    this.sideMenuOpenHandlerOnRoutes();
    this.userService.loggedInUserNameSubject.subscribe({
      next: (value) => {
        this.loggedInUserName = value;
      },
      error: (err) => {
        console.log(err);
      },
    });
    this.userService.loggedInUserProfilePicSubject.subscribe({
      next: (value) => {
        this.loggedInUserProfilePic = value;
      },
      error: (err) => {
        console.log(err);
      },
    });
    this.userService.loggedInUserSelectedDepartmentName.subscribe((res) => {
      this.departmentName = res as string;
    });
    await this.departmentsService.getDepartmentsForOptions().then((res) => {
      this.depOptions = res as any[];
    });
    await this.userService
      .getOneUserWithDetails(this.authService.getLoggedInUser().userId)
      .then((res) => {
        this.loggedInUser = res;
        const deparments = this.loggedInUser.department;
        this.userDepartments = [];
        this.depOptions.forEach((dep: any) => {
          deparments.forEach((userDep: any) => {
            if (dep._id === userDep._id) {
              this.userDepartments.push(dep);
            }
          });
        });
        this.userService.loggedInUserNameSubject.next(
          `${this.loggedInUser?.firstname} ${this.loggedInUser?.lastname}`,
        );
        this.userService.loggedInUserProfilePicSubject.next(
          this.loggedInUser.imageUrl ? this.loggedInUser.imageUrl : '',
        );
      });

    // this.router.events.subscribe((event) => {
    //   if (event instanceof NavigationEnd) {
    //     this.routerLink = this.router.url
    //     console.log(this.routerLink);
    //   }
    // });
  }

  filterByDepartment(dep?: any): void {
    if (dep) {
      this.userService.loggedInUserSelectedDepartment.next(dep._id);
      this.userService.loggedInUserSelectedDepartmentName.next(
        `${
          dep.company
            ? dep.department.name + ' - ' + dep.company.name
            : dep.department.name
        }`,
      );
    } else {
      this.userService.loggedInUserSelectedDepartment.next('');
      this.userService.loggedInUserSelectedDepartmentName.next(
        'All Departments',
      );
    }
  }
  sideMenuOpenHandlerOnRoutes() {
    this.router.events.subscribe((event) => {
      // if need add single or other routes with ids use this commented codes

      // if (event instanceof NavigationEnd) {
      //   const id = this.router.routerState.snapshot.root.firstChild?.firstChild?.params['id'];

      this.openMap = {
        user: false,
        fleet: false,
        driver: false,
        customer: false,
        agent: false,
        supplier: false,
        booking: false,
      };
      // if (this.router.isActive(`/admin/users/${id}`, true)) {
      //   this.openMap['user'] = true;
      // }
      if (!this.isCollapsed) {
        if (
          this.router.isActive('/admin/users', true) ||
          this.router.isActive('/admin/users/add-edit', true) ||
          this.router.isActive('/admin/users/roles', true) ||
          this.router.isActive('/admin/users/roles/add-edit', true)
        ) {
          this.openMap['user'] = true;
        } else if (
          this.router.isActive('/admin/fleets', true) ||
          this.router.isActive('/admin/fleets/add-edit', true)
        ) {
          this.openMap['fleet'] = true;
        } else if (
          this.router.isActive('/admin/drivers', true) ||
          this.router.isActive('/admin/drivers/add-edit', true)
        ) {
          this.openMap['driver'] = true;
        } else if (
          this.router.isActive('/admin/customers', true) ||
          this.router.isActive('/admin/customers/add-edit', true)
        ) {
          this.openMap['customer'] = true;
        } else if (
          this.router.isActive('/admin/agents', true) ||
          this.router.isActive('/admin/agents/add-edit', true) ||
          this.router.isActive('/admin/agents/view-booking', true)
        ) {
          this.openMap['agent'] = true;
        } else if (
          this.router.isActive('/admin/suppliers', true) ||
          this.router.isActive('/admin/suppliers/add-edit', true)
        ) {
          this.openMap['supplier'] = true;
        } else if (
          this.router.isActive('/admin/booking-transfer', true) ||
          this.router.isActive('/admin/booking-transfer/add-edit', true) ||
          this.router.isActive('/admin/booking-rent', true) ||
          this.router.isActive('/admin/booking-rent/add-edit', true) ||
          this.router.isActive('/admin/booking-other', true) ||
          this.router.isActive('/admin/booking-other/add-edit', true)
        ) {
          this.openMap['booking'] = true;
        }
      }
      // }
    });
  }
  routeLink(type: string) {
    switch (type) {
      case 'users':
        this.router.navigate(['/admin/users']);
        break;
      case 'user-add':
        this.router.navigate([
          '/admin/users/add-edit',
          { backRoute: 'ad_use' },
        ]);
        break;
      case 'roles':
        this.router.navigate(['/admin/users/roles']);
        break;
      case 'role-add':
        this.router.navigate([
          '/admin/users/roles/add-edit',
          { backRoute: 'ad_rol' },
        ]);
        break;
      case 'fleets':
        this.router.navigate(['/admin/fleets']);
        break;
      case 'fleet-add':
        this.router.navigate([
          '/admin/fleets/add-edit',
          { backRoute: 'ad_fle' },
        ]);
        break;
      case 'drivers':
        this.router.navigate(['/admin/drivers']);
        break;
      case 'driver-add':
        this.router.navigate([
          '/admin/drivers/add-edit',
          { backRoute: 'ad_dri' },
        ]);
        break;
      case 'suppliers':
        this.router.navigate(['/admin/suppliers']);
        break;
      case 'supplier-add':
        this.router.navigate([
          '/admin/suppliers/add-edit',
          { backRoute: 'ad_sup' },
        ]);
        break;
      case 'customers':
        this.router.navigate(['/admin/customers']);
        break;
      case 'customer-add':
        this.router.navigate([
          '/admin/customers/add-edit',
          { backRoute: 'ad_cus' },
        ]);
        break;
      case 'agents':
        this.router.navigate(['/admin/agents']);
        break;
      case 'agents-booking':
        this.router.navigate(['/admin/agents/view-booking']);
        break;
      case 'agent-add':
        this.router.navigate([
          '/admin/agents/add-edit',
          { backRoute: 'ad_age' },
        ]);
        break;
      case 'booking-transfer':
        this.router.navigate(['/admin/booking-transfer']);
        break;
      case 'booking-transfer-add':
        this.router.navigate([
          '/admin/booking-transfer/add-edit',
          { backRoute: 'ad_tra' },
        ]);
        break;
      case 'booking-rent':
        this.router.navigate(['/admin/booking-rent']);
        break;
      case 'booking-rent-add':
        this.router.navigate([
          '/admin/booking-rent/add-edit',
          { backRoute: 'ad_ren' },
        ]);
        break;
      case 'booking-other':
        this.router.navigate(['/admin/booking-other']);
        break;
      case 'booking-other-add':
        this.router.navigate([
          '/admin/booking-other/add-edit',
          { backRoute: 'ad_oth' },
        ]);
        break;
    }
  }

  openHandler(value: string): void {
    for (const key in this.openMap) {
      if (key !== value) {
        this.openMap[key] = false;
      }
    }
  }
}
